import CheckIcon from '@assets/icons/check.svg?react'
import DashIcon from '@assets/icons/dash.svg?react'
import { MMCheckbox as LibraryCheckbox } from 'mmfintech-portal-commons'
import type { MMCheckboxProps } from 'mmfintech-portal-commons/types'

type CheckboxVariant = 'primary' | 'dash' | 'circle' | 'checked-circle'
type CheckboxProps = Omit<MMCheckboxProps<CheckboxVariant>, 'checkedIcon' | 'checkedIconColor'>

export const MMCheckbox = (props: CheckboxProps) => {
  const icon = props.variant === 'dash' ? DashIcon : props.variant === 'circle' ? null : CheckIcon
  return <LibraryCheckbox checkedIcon={icon} {...props} />
}
